/* Product Tile Markup - You can play around with this to change the
information that appears on the Wishlisted Product tiles  */

var productCardMarkup = `<div class="swym-wishlist-grid">
   {{#products}} 
   <a href="{{du}}"aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor">
     <button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">
       <span class="swym-icon">
       </span>
     </button>
     <div class="swym-wishlist-image-wrapper">
       <img alt="" class="swym-wishlist-image" src="{{iu}}">
     </div>
     <button class="swym-is-button">
       <div class="swym-title swym-title-1">
         {{dt}}
       </div>
     </button>
     <div class="swym-variant-title swym-text swym-title-2 swym-variant-title-spacer">
       {{variantinfo}}
     </div>
     <div class="swym-product-price swym-text swym-text-1">
       <div class="swym-product-final-price swym-value">
         {{cu}}{{pr}}
       </div>
     </div>
     <button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}} swym-added{{/isInCart}}" data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-add-to-cart-btn swym-button swym-button-1 swym-is-button swym-is-button">
       {{#isInCart}}Added to cart{{/isInCart}}{{^isInCart}}Add to cart{{/isInCart}}
     </button>
   </a>
   {{/products}}
</div>`;

function getVariantInfo(variants) {
  try {
    let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
      variantinfo;
    if (variantKeys.length > 0) {
      variantinfo = variantKeys[0];
      if (variantinfo == "Default Title") {
        variantinfo = "";
      }
    } else {
      variantinfo = "";
    }
    return variantinfo;
  } catch (err) {
    return variants;
  }
}

function onAddToCartClick(e) {
  e.preventDefault();
  alert('this hit');
  var productId = e.currentTarget.getAttribute("data-product-id");
  var variantId = e.currentTarget.getAttribute("data-variant-id");
  var du = e.target.getAttribute("data-product-url");
  e.target.innerHTML = "Adding..";
  window._swat.replayAddToCart({
    empi: productId,
    du: du
  }, variantId, function(c) {
    e.target.innerHTML = "Added to Cart";
    e.target.setAttribute("data-state-cart", "swym-added");
    console.log("Successfully added product to cart.", c);
  }, function(e) {
    console.log(e);
  });
}

function onRemoveBtnClick(e) {
  e.preventDefault();
  var epi = +e.currentTarget.getAttribute("data-variant-id");
  var empi = +e.currentTarget.getAttribute("data-product-id");
  window._swat.fetch(function(products) {
    products.forEach(function(product) {
      if (epi && empi && product.epi == epi && product.empi == empi){
        window._swat.removeFromWishList(product, function() {
          if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
          }
          // window.SwymCallbacks.push(swymRenderWishlist);
        });
      }
    });
  })
}
  function appendProductToWishlist(product, dynamicId) {
    var wishlistContentsContainer = $("#" + dynamicId);
             var productHtml = `
                    <div class="horizontal-product flex items-center gap-4 md:gap-6 w-full">
                                                                   <div class="block">
                                                      <button id="${dynamicId}-btn" aria-label="Delete" data-variant-id=${product.epi} data-product-du=${product.du} data-product-lid=${product.lid} data-product-id=${product.empi} class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">
       <span class="swym-icon">X
       </span>
     </button>
                            </div>
                        <a class="horizontal-product__media media media--square relative overflow-hidden flex-auto" href="${product.du}" tabindex="-1">
                            <img src="${product.iu}" alt="${product.dt}" 
                                 srcset="${product.iu} 180w, ${product.iu} 360w, ${product.iu} 540w" 
                                 width="1066" height="1600" loading="lazy" is="lazy-image" class="loaded">
                        </a>
                        <div class="horizontal-product__details flex flex-col justify-start gap-1d5">
                            <div class="grid gap-1">
                                <div class="block">
                                    <a href="${product.du}" class="horizontal-product__title reversed-link font-medium text-base leading-tight">${product.dt}</a>
                                </div>
                            </div>
                            <div class="grid gap-1">
                                <div class="price flex flex-wrap items-end gap-2 text-sm">
                                    <span class="price__regular whitespace-nowrap">$${product.pr}</span>
                                </div>
                            </div>
                        </div>
                        <div class="horizontal-product__quantity shrink-0 text-sm sm:block">
                            <div class="grid gap-3">
                                <form method="post" action="/cart/add" id="product_form_${product.epi}" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data" is="product-form">
                                    <input type="hidden" name="form_type" value="product">
                                    <input type="hidden" name="utf8" value="✓">
                                    <input type="hidden" name="id" value="${product.epi}">
                                    <button type="submit" class="button button--primary button--small icon-with-text" is="hover-button" data-variant-id="${product.epi}">
                                        <span class="btn-fill" data-fill="" style="transform: translateY(var(--motion-translateY)); --motion-translateY: -76%;"></span>
                                        <span class="btn-text">
                                            <svg class="icon icon-plus icon-2xs" viewBox="0 0 12 12" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M2.5 6H6M9.5 6H6M6 6V2.5M6 6V9.5"></path>
                                            </svg>
                                            <span class="hidden md:block" data-sold-out="Sold Out">Add</span>
                                        </span>
                                        <span class="btn-loader">
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                        </span>
                                    </button>
                                    <input type="hidden" name="product-id" value="${product.epi}">
                                    <input type="hidden" name="section-id" value="sections--17053692493997__cart-drawer">
                                </form>
                            </div>
                        </div>
                    </div>
                `;             
    wishlistContentsContainer.append(productHtml)
  }
function swymRenderWishlist(swat) {

  // Get wishlist items
   $('#wishlist-items-container').html('');
console.log('xxxxxxx')
  swat.fetch(function(products) {
    if(products.length < 0)  {
      $('#wishlist-drawer-title').html('there is no item')
    }
    var formattedWishlistedProducts = products.map(function(p) {
          appendProductToWishlist(p, 'wishlist-items-container')
    });
  
  });
}

function swymRenderSaveForLater(swat) {
   $('#saved-items-container').html('');
   swat.SaveForLater.fetch('6a425d0b-40b2-4f85-9db3-86c70197cbd5', function(product) {
            product.items.forEach(item => {
              console.log(product )
              appendProductToWishlist(item, 'saved-items-container')
            })
      })
}

function attachClickListeners() {
  var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
  var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
  //   Add to cart Btns
  for (var i = 0; i < addToCartButtons.length; i++) {
    addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
  }
  //   Remove Buttons
  for (var k = 0; k < removeBtns.length; k++) {
    removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
  }
  console.log("Events attached!");
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
/* Init Here */



(function() {
  function onSubmitHandler(event) {
    if (document.body.classList.contains('template-cart') || theme.settings.cartType === 'page') return;
    
    event.preventDefault();

    this.activeElement = event.submitter || event.currentTarget;

 

    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));
    
    const config = theme.utils.fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    formData.append('sections', sectionsToBundle);
    formData.append('sections_url', window.location.pathname);


    config.body = {
      'sections': sectionsToBundle,
      'sections_url': window.location.pathname
      };
const cartDrawerElement = document.getElementById('CartDrawer');
let dataSectionId = '';
if (cartDrawerElement) {
  dataSectionId = cartDrawerElement.getAttribute('data-section-id');
} 
    const url = `/?sections=${dataSectionId}`;

    // Function to handle the response
    function handleResponse(response) {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json(); // Assuming the server returns JSON
    }

    // Fetch request
    fetch(url)
      .then(handleResponse)
      .then(async (data) => {
        console.log('Response Data:', data);


      const cartJson = await (await fetch(`${theme.routes.cart_url}`, { ...theme.utils.fetchConfig()})).json();
      cartJson['sections'] = data;
    console.log( theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson }));

        
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {

      });
  }
  function initializeSaveForLater(swat) {
    let onSuccess = function(response) {
      // WARN Remove logs in production code
      console.log("Successfully Initialized, And we created a Save for Later List", response);
      // Store the SFL list ID in the window object for global access.
      window._saveforLaterListId = response.list.lid; 
      swat.SaveForLater.fetch('6a425d0b-40b2-4f85-9db3-86c70197cbd5', function(product) {
            product.items.forEach(item => {
              appendProductToWishlist(item, 'saved-items-container')
            })
      })
    }

    let onError = function(error) {
      // Error is an xhrObject
      // WARN Remove logs in production code
      console.log("There was an Error, while creating the Save For Later List", error);
    }

    // Call the Init function.
    swat.SaveForLater.init(onSuccess, onError);
    let event = 'sw:addedtocart';

// Define the event listener function
let listener = function(e) { 

  var data = e.detail.d.productData;  
onSubmitHandler(e);

 swymRenderSaveForLater(swat);
};

// Add listener for the 'addedtocart' event to the Swym Event Layer
swat.evtLayer.addEventListener(event, listener);
    
  }

function initializeRemoveFromWishlist(swat) {

    let event = 'sw:removedfromwishlist';
// Define the event listener function
let listener = function(e) { 

swymRenderWishlist(swat);
};

// Add listener for the 'addedtocart' event to the Swym Event Layer
swat.evtLayer.addEventListener(event, listener);
    
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(initializeSaveForLater);
      window.SwymCallbacks.push(swymRenderWishlist);
  window.SwymCallbacks.push(initializeRemoveFromWishlist);

})();



$(document).on('click', '#saved-items-container-btn', function (e) {
  e.preventDefault();
  e.stopPropagation();
  

 var epi = +e.currentTarget.getAttribute("data-variant-id");

  var empi = +e.currentTarget.getAttribute("data-product-id");
  var du = e.currentTarget.getAttribute("data-product-du");
  var lid =  e.currentTarget.getAttribute("data-product-lid");;
  let products = [{
	du: du,
	empi: empi,
	epi: epi,
}];



// Success callback.
let onSuccess = function(response) {
  swymRenderSaveForLater(window._swat);
	console.log("Successfully Removed the products From Save for Later List", response);
}

// Error Callback. 
let onError = function(error) {
	// Error is an xhrObject
	console.log("There was an Error, while Removing products to the Save For Later List", error);
}
    console.log(window._swat.SaveForLater.remove(lid,products, onSuccess, onError));

});



$(document).on('click', '#wishlist-items-container-btn', function (e) {
  e.preventDefault();
  e.stopPropagation();
  
onRemoveBtnClick(e)
swymRenderWishlist(window._swat)


});



$(document).on('click', '#saved-items-container-btn', function (e) {
  e.preventDefault();
  e.stopPropagation();
  

 var epi = +e.currentTarget.getAttribute("data-variant-id");

  var empi = +e.currentTarget.getAttribute("data-product-id");
  var du = e.currentTarget.getAttribute("data-product-du");
  var lid =  e.currentTarget.getAttribute("data-product-lid");;
  let products = [{
	du: du,
	empi: empi,
	epi: epi,
}];



// Success callback.
let onSuccess = function(response) {
  swymRenderSaveForLater(window._swat);
	console.log("Successfully Removed the products From Save for Later List", response);
}

// Error Callback. 
let onError = function(error) {
	// Error is an xhrObject
	console.log("There was an Error, while Removing products to the Save For Later List", error);
}
    console.log(window._swat.removeFromWishList(lid,products, onSuccess, onError));


});
